import { colors } from "constants/colors";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { StyledText } from "styles/Text";
import { formatTime } from "util/date";

interface Props {
  onReached?: () => void; // 가준 시간에 도달 시 호출
  isFloating?: boolean;
}

const CountdownTimer = ({ onReached, isFloating }: Props) => {
  const TARGET_HOUR = 7; // 24시간 기준
  const TARGET_MIN = 0;
  const TARGET_SEC = 0;

  const getNextTargetTime = () => {
    const now = new Date();
    const target = new Date();

    target.setHours(TARGET_HOUR, TARGET_MIN, TARGET_SEC, 0);

    // 이미 오늘 7시 지났으면 다음날 7시로 설정
    if (target.getTime() <= now.getTime()) {
      target.setDate(target.getDate() + 1);
    }

    return target;
  };

  const [targetTime, setTargetTime] = useState<Date>(getNextTargetTime);
  const [timeLeft, setTimeLeft] = useState(() =>
    Math.max(targetTime.getTime() - Date.now(), 0),
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        const next = prev - 1000;

        // 목표 시간 도달
        if (next <= 0) {
          onReached && onReached();
          const newTarget = getNextTargetTime();
          setTargetTime(newTarget);
          return newTarget.getTime() - Date.now();
        }

        return next;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onReached]);

  return isFloating ? (
    <StyledFloatingContainer>
      <StyledTimer>남은 시간 {formatTime(timeLeft)}</StyledTimer>
    </StyledFloatingContainer>
  ) : (
    <StyledFixedContainer>
      <StyledImg
        src={require("assets/images/store/ic_hourglass_normal_outlined_black_s.png")}
      />
      <StyledText.Headline15 color={colors.mainOrange}>
        남은 시간 {formatTime(timeLeft)}
      </StyledText.Headline15>
    </StyledFixedContainer>
  );
};

export default CountdownTimer;

const StyledFixedContainer = styled.div`
  border-radius: 5px;
  background-color: ${colors.subOrange1};
  padding: 6px 0px;
  text-align: center;
  margin-bottom: 16px;
`;

const StyledImg = styled.img`
  width: 22px;
  height: 22px;
`;

const StyledFloatingContainer = styled.div`
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  width: fit-content;
  margin: auto;
`;

const StyledTimer = styled.div`
  border-radius: 20px;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray2};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  padding: 6px 12px;
  margin-top: 8px;
  font-size: 11px;
  font-style: normal;
  line-height: 16px;
  letter-spacing: -0.55px;
  color: ${colors.subBody3};
`;
